import type { AsyncNamespace, OttoNexus } from "@otto-ec/global-resources/nexus";
// !important: must be used to ensure ssr compatibility
import { otto } from "@otto-ec/global-resources/nexus";
import type { DataContainer } from "./lib/datacontainer.js";
import type { Tracking } from "./nexus.js";

export type * from "./nexus.js";
export type * from "./syncronous.js";
export type * from "./event-q-bus.js";
export type * from "./lib/datacontainer.js";
export type * from "./lib/eventMergeContext.js";
export type * from "./lib/feature-typing.js";

/**
 * Describes the contents of a Nexus Namespace exposing tracking bct.
 */
export type TrackingApi = OttoNexus["tracking"];

/**
 * Nexus namespace exposing public api of tracking bct.
 */
export const tracking: TrackingApi = otto.tracking;

/** Nexus function exposing instance of {@link Tracking.submitEvent} {@inheritDoc Tracking.submitEvent} @function*/
export const submitEvent: TrackingApi["submitEvent"] = tracking.submitEvent;
/** Nexus function exposing instance of {@link Tracking.submitEventMerge} {@inheritDoc Tracking.submitEventMerge} @function*/
export const submitEventMerge: TrackingApi["submitEventMerge"] = tracking.submitEventMerge;
/** Nexus function exposing instance of {@link Tracking.submitMerge} {@inheritDoc Tracking.submitMerge} @function */
export const submitMerge: TrackingApi["submitMerge"] = tracking.submitMerge;
/** Nexus function exposing instance of {@link Tracking.submitMove} {@inheritDoc Tracking.submitMove} @function */
export const submitMove: TrackingApi["submitMove"] = tracking.submitMove;
/** Nexus function exposing instance of {@link Tracking.submitMiniAction} {@inheritDoc Tracking.submitMiniAction} @function */
export const submitMiniAction: TrackingApi["submitMiniAction"] = tracking.submitMiniAction;
/** Nexus function exposing instance of {@link Tracking.createEventMergeContext} {@inheritDoc Tracking.createEventMergeContext} @function */
export const createEventMergeContext: TrackingApi["createEventMergeContext"] = tracking.createEventMergeContext;
/** Nexus function exposing instance of {@link Tracking.trackOnNextPageImpression} {@inheritDoc Tracking.trackOnNextPageImpression} @function */
export const trackOnNextPageImpression: TrackingApi["trackOnNextPageImpression"] = tracking.trackOnNextPageImpression;
/** Nexus function exposing instance of {@link Tracking.createContext} {@inheritDoc Tracking.createContext} @function */
export const createContext: TrackingApi["createContext"] = tracking.createContext;
/** Nexus function exposing instance of {@link Tracking.replaceContext} {@inheritDoc Tracking.replaceContext} @function */
export const replaceContext: TrackingApi["replaceContext"] = tracking.replaceContext;
/** Nexus function exposing instance of {@link Tracking.closeContext} {@inheritDoc Tracking.closeContext} @function */
export const closeContext: TrackingApi["closeContext"] = tracking.closeContext;
/** Nexus function exposing instance of {@link Tracking.getPageMergeId} {@inheritDoc Tracking.getPageMergeId} @function */
export const getPageMergeId: TrackingApi["getPageMergeId"] = tracking.getPageMergeId;
/** Nexus function exposing instance of {@link Tracking.createPage} {@inheritDoc Tracking.createPage} @function */
export const createPage: TrackingApi["createPage"] = tracking.createPage;

/**
 * Allows to retrieve {@link OttoNexus.tracking} as pretyped version
 * Meaninig all function will use given Shape as their data container
 *
 * @template T - Shape of DataContainer
 * @returns {@link OttoNexus.tracking} with pretyped functions
 */
export function get<T extends DataContainer>(): AsyncNamespace<Tracking<T>> {
  return tracking;
}
